import { Label, TextInput } from 'flowbite-react';
import React from 'react';
import * as styles from './customInput.styles';

interface CustomInputProps {
  value?: number | string | undefined;
  id?: string;
  label: string ;
  name: string;
  lefticon?:any;
  rightIcon?: any;
  onChange?: (e:any)=>void;
  onRightIconClick?: () => void;
  type?: string;
  onFocus?: ()=>void
  onBlur?: ()=>void,
  placeholder?: string,
  className?:string,
  readonly?:boolean,
  maxLength?:number,
  // inputMode?:string
}

const CustomInput = ({
  value,
  id,
  label,
  name,
  rightIcon: RightIcon,
  onChange,
  onRightIconClick, 
  type = 'text', 
  onFocus,
  onBlur,
  placeholder,
  lefticon,
  className,
  readonly=false,
  maxLength,
}: CustomInputProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = e.target.value;

    if (type === "number") {
      // Allow only positive numbers and empty input
      if (!/^\d*\.?\d*$/.test(newValue)) return;
    }

    if (onChange) {
      onChange(e);
    }
  };
  return (
    <div className={styles.inputDiv}>
      {label && <Label value={label} htmlFor={id ?? name} />}
      <div className={`relative ${className}`}>
        <TextInput
          id={id ?? name}
          value={value}
          name={name}
          onChange={handleChange}
          type={type}
          onFocus={onFocus}
          onBlur={onBlur}
          placeholder={placeholder}
          icon={lefticon}
          readOnly={readonly}
          inputMode={type === 'number' ? 'numeric' : undefined} // Only set for numeric inputs
          />
        {RightIcon && (
          <RightIcon
            className='absolute right-2 top-3 cursor-pointer'
            onClick={onRightIconClick}
          />
        )}
      </div>
    </div>
  );
};

export default CustomInput;
